import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import Resources from '../resourceLinks/ResourceLinks';
import Image from '../../objects/image/SecondaryImage';
import LibraryImage from '../../objects/image/SecondaryLibraryImage';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appConstants from "../../../constants/appConstants";
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as assetConstants from '../../../constants/assetConstants';
import * as xAPIHelper from '../../../helpers/xAPIHelper';
import * as localStorage from '../../../localStorage/localStorage';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';
import _ from 'lodash';

class PrintResponses extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            shortResponseQuestions: this.props.shortResponseQuestions,
            status: objectConstants.STATUS_NOT_STARTED,
            locale: appHelper.getLocalData(this.props.screenObject),
            showProgressionButton: false,
            printableAssets: [],
            renderQuestions: false,
            checkGetXAPIResponse: false,
            screenStatus: "",
            checkComplete: false,
            resourceLinks: [],
            isResourceObject: appHelper.isDefined(this.props.callbacks.checkIsResourceScreen) && this.props.callbacks.checkIsResourceScreen(),
            hasResources: false,
            resourcesAreComplete: false,
            allowScroll: appHelper.allowScroll(this.props.callbacks.getBiteId(), this.props.callbacks.getScreenId(), this.props.screenObject.asset_id),
            print_label: appHelper.getLocaleString("print_label"),
            no_response_provided_label: appHelper.getLocaleString("no_response_provided_label"),
        };
        this.handleProgression = this.handleProgression.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.disableProgression = this.disableProgression.bind(this);
        this.show = this.show.bind(this);
        this.onShowComplete = this.onShowComplete.bind(this);
        this.onProgressionBtnClicked = this.onProgressionBtnClicked.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.onResourcesComplete = this.onResourcesComplete.bind(this);
        this.setResources = this.setResources.bind(this);
        this.onRendered = this.onRendered.bind(this);
        this.getAssetsToPrint = this.getAssetsToPrint.bind(this);
        this.getXAPIResponse = this.getXAPIResponse.bind(this);
        this.print = this.print.bind(this);
        this.printStyles = this.printStyles.bind(this);
    }

    componentDidMount() {
        this.setResources();
        this.getScreenStatus();
        this.show();
        this.getAssetsToPrint();
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                print_label: appHelper.getLocaleString("print_label"),
                no_response_provided_label: appHelper.getLocaleString("no_response_provided_label"),
            });
        }
    }

    componentDidUpdate() {

        if (this.state.checkComplete) {

            this.onComplete();
        }

        if (this.state.checkGetXAPIResponse) {
            this.getXAPIResponse();
        }
    }

    getAssetsToPrint() {
        let printableAssets = [];
        let tempAssests = [];
        let allQuestions = Object.assign([], this.state.shortResponseQuestions);

        if (this.state.screenObject.print_responses_from === objectConstants.PRINT_FROM_THIS_BITE) {
            tempAssests = appHelper.getPrintableAssetsByBite(this.props.callbacks.getBiteId());
        } else {
            //all tempAssests
            printableAssets = appHelper.getAllPrintableAssets();
        }

        for (let i = 0; i < tempAssests.length; i++) {
            let asset = tempAssests[i];
            let assetLocale = appHelper.getLocalData(asset);
            let renderedQuestions = [];
            _.forEach(asset.questions, function (question) {
                let questionData = appHelper.getArrayObjectByKey(allQuestions, "id", question.id);
                if (appHelper.isDefined(questionData.id)) {
                    renderedQuestions = dataHelper.immutablePush(renderedQuestions, questionData);
                }
            });

            let renderedQuestion = {
                bite_id: asset.bite_id,
                screen_id: asset.screen_id,
                asset_id: asset.asset_id,
                locale: assetLocale,
                show_title: asset.show_title,
                renderedQuestions: renderedQuestions,
            };

            printableAssets = dataHelper.immutablePush(printableAssets, renderedQuestion);
        }

        this.setState(
            {
                printableAssets: Object.assign([], printableAssets),
                renderQuestions: localStorage.tracking_type !== appConstants.TRACKING_TYPE_XAPI && localStorage.tracking_type !== appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2,
                checkGetXAPIResponse: true
            }
        );
    }

    getXAPIResponse() {
        this.setState({checkGetXAPIResponse: false});

        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            let updatedAssets = 0;
            let printableAssets = Object.assign([], this.state.printableAssets);
            for (let a = 0; a < printableAssets.length; a++) {
                let asset = printableAssets[a];
                let renderedQuestions = Object.assign([], asset.renderedQuestions);
                let returnedResponses = 0;
                let params = {
                    renderedQuestions: renderedQuestions,
                    bite_id: asset.bite_id,
                    screen_id: asset.screen_id,
                    asset_id: asset.asset_id,
                };

                let interactionDataArray = xAPIHelper.getShortResponseIds(asset, params);

                for (let i = 0; i < interactionDataArray.length; i++) {
                    let interactionData = interactionDataArray[i];
                    this.props.actions.getActvityStatement(interactionData).then((responseObj) => {
                        if (appHelper.isDefined(responseObj.statement)) {
                            let response = responseObj.statement.result.response;
                            let responseQuestion = appHelper.getArrayObjectByKey(renderedQuestions, "id", responseObj.id);
                            let responseQuestionIndex = appHelper.getArrayObjectIndexByKey(renderedQuestions, "id", responseObj.id);
                            responseQuestion = Object.assign({}, responseQuestion, {
                                response: response,
                            });
                            renderedQuestions = dataHelper.immutableSplice(renderedQuestions, responseQuestionIndex, 1, responseQuestion);
                            returnedResponses++;

                            if (returnedResponses === renderedQuestions.length) {
                                updatedAssets++;
                                asset = Object.assign({}, asset, {
                                    renderedQuestions: renderedQuestions
                                });

                                printableAssets = dataHelper.immutableSplice(printableAssets, a, 1, asset);
                            }
                        } else {
                            updatedAssets++;
                            asset = Object.assign({}, asset, {
                                renderedQuestions: renderedQuestions
                            });
                            printableAssets = dataHelper.immutableSplice(printableAssets, a, 1, asset);
                        }

                        if (updatedAssets === printableAssets.length) {
                            this.setState({
                                printableAssets: Object.assign([], printableAssets),
                                renderQuestions: true,
                            });
                        }

                    }).catch(error => {
                    });
                }
            }

        }

    }

    setResources() {
        let resourceLinks = appHelper.setResourceLinks(this.state.screenObject);
        let hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);

        this.setState({
            resourceLinks: Object.assign([], resourceLinks),
            hasResources: resourceLinks.length > 0,
            resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources
        });

    }

    getScreenStatus() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        this.setState({
            screenStatus: screenStatus,
            status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
        });
    }

    getObjectStatus() {
        if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {

            this.onComplete();

        } else {
            let objectUserData = {};
            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                let subScreenParent = this.props.callbacks.getSubScreenParent();
                let screen_id = this.props.callbacks.getScreenId();
                if (appHelper.isDefined(subScreenParent)) {
                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                } else if (this.state.isResourceObject) {
                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
                } else {
                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }
            }
            if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
                this.setState({status: objectConstants.STATUS_COMPLETE, checkComplete: true});
            } else {
                this.setState({checkComplete: true});
            }

        }

    }


    show() {
        this.scrollToTop();
        let optionRef = this.refs[`${this.state.screenObject.asset_id}_text`];
        TweenLite.set(optionRef, {height: "auto"});
        TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
            height: 0,
            ease: Expo.easeInOut
        }).eventCallback("onComplete", this.onRendered);
    }

    onRendered() {
        if (this.state.isResourceObject) {
            this.props.callbacks.onObjectRendered();
        }
        this.getObjectStatus();
    }

    onShowComplete() {
        this.setState({isVisible: true, checkComplete: false});
    }


    scrollToTop() {
        if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
            let question = this.refs[`${this.state.screenObject.asset_id}_text`];
            let scrollTo = this.props.callbacks.scrollTo;

            setTimeout(function () {
                if (appHelper.isDefined(scrollTo)) {
                    scrollTo(question.offsetTop);
                }
            }, objectConstants.SCROLL_TO);
        }
    }

    onComplete() {
        this.setState({checkComplete: false});
        let hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
        if (this.state.resourcesAreComplete) {
            if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
                if (!hasNextObject && !this.state.isResourceObject) {
                    //console.log('progression 1')
                    this.handleProgression();
                    this.enableProgression();
                } else if (!hasNextObject && this.state.isResourceObject) {
                    this.handleProgression();
                } else if (this.state.isResourceObject) {
                    this.handleProgression();
                } else {
                    this.enableProgression();
                }

            } else {
                this.handleProgression();
            }
        }
        this.scrollToTop();
    }

    enableProgression() {
        if (!this.props.callbacks.isReviewMode()) {
            this.setState({showProgressionButton: true});
        }
    }

    disableProgression() {
        this.setState({showProgressionButton: false});
    }

    handleProgression() {
        let progressionRule = this.state.screenObject.progression;
        let progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
        let progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
        let completionData = {
            progression: progressionRule,
            progressionType: progressionType,
            progressionGoToId: progressionGoToId,
            asset_id: this.state.screenObject.asset_id,
            status: objectConstants.STATUS_COMPLETE,
            showProgressionButton: false,
            asset_type_code: this.state.screenObject.asset_type_code,
            navigateToNextScreen: !this.state.isResourceObject && appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE
        };

        this.props.callbacks.onObjectComplete(completionData);
        //t

    }

    onProgressionBtnClicked() {
        this.setState({showProgressionButton: false});
        if (this.props.callbacks.hasNextObject(this.props.index) || this.state.isResourceObject) {
            this.handleProgression();
        } else {
            this.props.callbacks.navigateToNextScreen();
        }
    }


    onResourcesComplete() {
        if (!this.state.resourcesAreComplete) {
            this.setState({resourcesAreComplete: true, checkComplete: true});
        }
    }

    print(){
        let mywindow = window.open('', 'Print', 'height=800,width=600');
        mywindow.document.write(`<html><head><title>${this.state.locale.label}</title>`);
        mywindow.document.write(`</head><body >`);
        mywindow.document.write(`<style type="text/css" >`);
        mywindow.document.write(this.printStyles());
        mywindow.document.write(`</style>`);
        mywindow.document.write(`<p class="title">${this.state.locale.label}</p>`);
        if(appHelper.isDefined(this.state.locale.description) && this.state.locale.description.length > 0 && this.state.locale.description !== "<p><br></p>") {
            mywindow.document.write(`<p>${this.state.locale.description}</p>`);
        }

        for(let a = 0; a < this.state.printableAssets.length; a++){
            let asset = this.state.printableAssets[a];
            mywindow.document.write(`<div class="question-separator-container">`);
            if(asset.show_title){
                mywindow.document.write(`<p class="question">${asset.locale.label}</p>`);
            }

            if(appHelper.isDefined(asset.locale.description) && asset.locale.description.length > 0 && asset.locale.description !== "<p><br></p>"){
                mywindow.document.write(`<p class="label">${asset.locale.description}</p>`);
            }

            for(let i = 0; i < asset.renderedQuestions.length; i++){
                let question = asset.renderedQuestions[i];
                let qLocale = appHelper.getLocalData(question);
                mywindow.document.write(`<p class="label"><strong>${qLocale.prompt}</strong></p>`);
                if(question.response.length > 0){
                    mywindow.document.write(`<div class="embedded-response">${question.response}</div>`);
                }else{
                    mywindow.document.write(`<div class="embedded-response"><em>${this.state.no_response_provided_label}.</em></div>`);
                }
            }

            mywindow.document.write(`</div>`);
        }
        mywindow.document.write(`</body></html>`);

        mywindow.document.close();
        mywindow.focus();
        mywindow.print();
        mywindow.close();

        return true;
    }

    printStyles(){
        return `
        @media print {
            html, body {
               font-family: 'Helvetica Neue', Helvetica, Arial, san-serif;
	            line-height: 130%;
	            padding: 0;
	            font-size: 12px;
	            color: #333;
            }
            
            .question-separator-container{
            
                padding: 20px 12px;
                border-top: 1px solid #e5e5e5;
            }
            
            .title{
                text-align: center;
                font-size: 16px;
                font-family: Arial Rounded MT Bold, Helvetica Rounded, Arial, sans-serif;
            }
            
            .question{
                font-family: Arial Rounded MT Bold, Helvetica Rounded, Arial, sans-serif;
                font-size: 14px;
            }
           
            .label{
                display: block;
          
                font-weight: bold;
             
            }
            
            .response{
                padding: 0 0 0 20px;
            }
            
            .embedded-response{
              font-family: 'Helvetica Neue', Helvetica, Arial, san-serif;
                padding: 0 12px;
            }
        }`;
    }


    render() {
        return (
            <div className={`learner-action`} ref={`${this.state.screenObject.asset_id}_text`}>
                <div className="question-wrapper">


                    <div className="object-container">
                        {
                            this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label.length > 0
                                ? <h4 dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                                : null
                        }
                        {appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                            ?
                            <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                            : null
                        }
                    </div>
                    {
                        this.state.renderQuestions
                            ?
                            <div>
                                {this.state.printableAssets.map(asset =>
                                    <div className="question-separator object-container" key={asset.asset_id}>

                                        {
                                            asset.show_title
                                                ? <h4 dangerouslySetInnerHTML={{__html: asset.locale.label}}/>
                                                : null
                                        }

                                        {
                                            appHelper.isDefined(asset.locale.description) && asset.locale.description.length > 0 && asset.locale.description !== "<p><br></p>"
                                                ?
                                                <div dangerouslySetInnerHTML={{__html: asset.locale.description}}/>
                                                :
                                                null
                                        }

                                        {asset.renderedQuestions.map(question =>

                                            <div key={question.id}>
                                                <br/>
                                                <div
                                                    dangerouslySetInnerHTML={{__html: appHelper.getLocalData(question).prompt}}/>
                                                {
                                                    question.response.length > 0
                                                        ?
                                                        <div className="embedded-response"
                                                             dangerouslySetInnerHTML={{__html: question.response}}/>
                                                        :
                                                        <div className="embedded-response"><em>{this.state.no_response_provided_label}.</em></div>
                                                }
                                            </div>
                                        )}
                                    </div>
                                )}
                                <div className="text-center">
                                    <button className={`btn btn-lg guroo-btn print-btn`}
                                            onClick={this.print}>{this.state.print_label}
                                    </button>
                                </div>
                            </div>
                            :
                            <div className="pl-circle content">
                                <div className="pl-circle1 pl-child"/>
                                <div className="pl-circle2 pl-child"/>
                                <div className="pl-circle3 pl-child"/>
                                <div className="pl-circle4 pl-child"/>
                                <div className="pl-circle5 pl-child"/>
                                <div className="pl-circle6 pl-child"/>
                                <div className="pl-circle7 pl-child"/>
                                <div className="pl-circle8 pl-child"/>
                                <div className="pl-circle9 pl-child"/>
                                <div className="pl-circle10 pl-child"/>
                                <div className="pl-circle11 pl-child"/>
                                <div className="pl-circle12 pl-child"/>
                            </div>
                    }

                </div>

                {this.state.showProgressionButton && this.state.renderQuestions
                    ? <Button label={this.state.locale.progression_label}
                              id={`${this.state.screenObject}_button`}
                              onClick={this.onProgressionBtnClicked}/>
                    : null
                }
            </div>
        );
    }
}

PrintResponses.propTypes = {
    screenObject: PropTypes.object.isRequired,
    index: PropTypes.number,
    callbacks: PropTypes.object.isRequired,
    shortResponseQuestions: PropTypes.array.isRequired,
    characterPose: PropTypes.object,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

PrintResponses.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        shortResponseQuestions: state.userData.short_response_questions,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrintResponses);



/** WEBPACK FOOTER **
 ** ./src/components/objects/shortResponse/PrintResponses.js
 **/